import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip, Textarea, Select, Modal } from 'components';
import { PlanningService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals } from 'utils';
import ModalRoutesMaster from './modal-routes-master';
import { SettingIcon } from 'assets/icons';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalRoutes extends React.Component<Props> {	

	state = {
		form: {
			comments: this.props.item?.planning_comments || '',
			route_id: this.props.item?.route_id || ''
		},
		routes: [],
		visible: false
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await PlanningService.admin.getRoutes();
		this.setState({
			routes: res.routes || []
		});
	}

	submit = async(e: any) => {
		e.preventDefault();
		await PlanningService.admin.save({
			quote_id: this.props.item?.id,
			...this.state.form
		});
		this.props.onClose();
		Globals.showSuccess("Se ha guardado la planificación correctamente");
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	onClose = () => {
		this.setState({
			visible: false
		},() => this.load());
	}

	viewRoutes = () => {
		this.setState({
			visible: true
		});	
	}
	
	render() {
		const { visible } = this.state;

		return (
			<div id="modal-select-routes">
				<Modal
		          className="modal-create-routes"
		          visible={ visible }
		          title="Rutas"
		          centered
		          animation={ false }
		          onClose={ () => this.onClose() }
		        >
		          {/* 
		          // @ts-ignore */}
		          <ModalRoutesMaster
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	{
		      		!visible && (
		      			<>
		      				<div className="container-address">
								<p className="item-address"><strong>Cliente:</strong> { this.props.item?.user?.full_name || '-' }</p>
								<p className="item-address"><strong>Ubicación:</strong> { this.props.item?.city || '-' }</p>
							</div>
							<div className="container-select">
								<div>
									<Select
										label="Ruta"
										name="route_id"
										onChange={ (e: any) => this.change(e) }
										value={ this.state.form.route_id }
										options={ this.state.routes.map((item: any) => {
											return {
												value: item.id,
												label: item.name
											}
										}) } />
								</div>
								<button className="btn btn-add" onClick={ () => this.viewRoutes() }>
									<img src={ SettingIcon } />
								</button>
							</div>
							<Textarea
								rows={ 3 }
								label="Observaciones (Opcional)"
								name="comments"
								onChange={ this.change }
			                    value={ this.state.form.comments } />
				            <div className="container-buttons">
								<div className="row">
									<div className="col-md-6">
										<button className="btn btn-red" onClick={ () => this.props.onClose() }>
											Cancelar
										</button>
									</div>
									<div className="col-md-6">
										<button className="btn btn-green" onClick={ (e) => this.submit(e) }>
											Aceptar
										</button>	
									</div>
								</div>
							</div>
		      			</>
		      		)
		      	}
			</div>
		)
	}
}

export default ModalRoutes;